import { UrlStateConfig } from '@cdw-ae/url-params';

export const GenericUrlParamConfig: UrlStateConfig = {
  fieldAbbreviations: {
    // Shorten common field names for cleaner URLs
    // This would transform URLs from:
    // ?queryParamPrefix=orgUnitPath:startsWith:"/org-unit-name"
    // to:
    // ?filters=ou:sw:"/org-unit-name"
    id: 'did',
    vendorId: 'vid',
    'vendorProperties.google.orgUnitPath': 'ou',
    serialNumber: 'sn',
    annotatedAssetId: 'astId',
    annotatedUser: 'astUser',
    annotatedLocation: 'loc',
    make: 'mk',
    model: 'mdl',
    notes: 'nts',
    osVersionStatus: 'osvs',
    'vendorProperties.google.autoUpdateThrough': 'aue',
    'vendorProperties.google.lastKnownUser': 'ru',
    diskUsed: 'du',
    lastSync: 'ls',
    batteryHealth: 'bh',
    osVersion: 'osv',
    status: 's',
  },
  operatorAbbreviations: {
    equals: 'eq',
    greaterThan: 'gt',
    lessThan: 'lt',
    between: 'bt',
    startsWith: 'sw',
    contains: 'ct',
    greaterThanOrEqual: 'gte',
    lessThanOrEqual: 'lte',
    oneOf: 'in',
    is: 'is',
    isNot: 'not',
  },
};

export const DeviceSearchUrlParamConfig: UrlStateConfig = {
  ...GenericUrlParamConfig,
  fieldAbbreviations: {
    ...GenericUrlParamConfig.fieldAbbreviations,
    'vendorProperties.google.diskUsedCategory': 'du',
  },
};
